/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetAllocationCategoryType = {
    ASSET_CLASS_BREAKDOWN: 'asset_class_breakdown'
} as const;
export type AssetAllocationCategoryType = typeof AssetAllocationCategoryType[keyof typeof AssetAllocationCategoryType];


export function instanceOfAssetAllocationCategoryType(value: any): boolean {
    for (const key in AssetAllocationCategoryType) {
        if (Object.prototype.hasOwnProperty.call(AssetAllocationCategoryType, key)) {
            if (AssetAllocationCategoryType[key as keyof typeof AssetAllocationCategoryType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetAllocationCategoryTypeFromJSON(json: any): AssetAllocationCategoryType {
    return AssetAllocationCategoryTypeFromJSONTyped(json, false);
}

export function AssetAllocationCategoryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocationCategoryType {
    return json as AssetAllocationCategoryType;
}

export function AssetAllocationCategoryTypeToJSON(value?: AssetAllocationCategoryType | null): any {
    return value as any;
}

export function AssetAllocationCategoryTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetAllocationCategoryType {
    return value as AssetAllocationCategoryType;
}

